import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage1Avaleht from "./pages/Webpage1Avaleht";
import Webpage4V__imalused from "./pages/Webpage4V__imalused";
import Webpage5E_arved from "./pages/Webpage5E_arved";
import Webpage7Kontakt from "./pages/Webpage7Kontakt";
import Webpage8Privaatsuspoliitika from "./pages/Webpage8Privaatsuspoliitika";
import Webpage9Templates from "./pages/Webpage9Templates";
import Webpage10Kassaseadmed from "./pages/Webpage10Kassaseadmed";
import Webpage11Lehte_ei_leitud from "./pages/Webpage11Lehte_ei_leitud";
import Webpage49Tingimused from "./pages/Webpage49Tingimused";
import Webpage50Kassas__steemid from "./pages/Webpage50Kassas__steemid";
import Webpage51Kassas__steemide_m____k from "./pages/Webpage51Kassas__steemide_m____k";
import Webpage52Pos_tarkvara from "./pages/Webpage52Pos_tarkvara";
import Webpage53T__nuleht from "./pages/Webpage53T__nuleht";
import Webpage54paketid from "./pages/Webpage54paketid";

var baseURL = 'https://web.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI2IiwianRpIjoiNWE4ZTE2YTA1ZWU2MDllZGI4ZmJjMzViY2QzYWNkMmFkZTdhZWI5MjY2MDMyNzNhOGI3MzQzNmYwNzdlMTY5NzQyY2U4MjYyYTZkMTg3ZjciLCJpYXQiOjE3ODQ1MjU2NzcuMTkzNzUzLCJuYmYiOjE3ODQ1MjU2NzcuMTkzNzU3LCJleHAiOjE3ODQ2MTIwNzcuMTg5MDM3LCJzdWIiOiI4Iiwic2NvcGVzIjpbXX0.e-VZk-MaRPojitSrr6BNSbmHctBQm2CsbhExOu3CtJbtvLMn19EBPNl5-y12bmFVQZwUd10sYh390h0dygoAE0fVv25PEjeX6DircFv6cS7M_H5gI9KjbfAHas7_DTUcmnjgusrD5ES9RzDobi6qPpQhv6R4CbIT1q5iAyJ1DYDo0eKvwdhIn9ucC-0KHA9-9pkfYbnqnfvcMTX4JhzC-Hx3gr7yE5yNHrWmlYu8zPX1iJXuHQrgE2AzxbMqLfg2oiX7aWpyQDtAab_S6Gn4OXMUKHRtD4ql5_Az9nCJmy0bcLSvbr_UDGX_0Dwoaj3yknYJ71yi5esJZ1ByqOekDL6rjHVpONSqTWGNlbuOSDsZhwYosXhJFUv3LI24fYQyyD6TNUlnW7_Xlp340mmK8WRKA9wrqrxj3xFrwk_f4FZgUdPUCs7h3QiQgQ7UUQc8ANYbkrhc4KA13VpzuDX204fMu-cB72b60s9vgfv6vMrnwCgetMWlNuUehJwrJhYbd66-gWpZb12f2A2_1Al3FsW8xIZEx2_ITQQADCDVtzGjkhGVp9Ts0rGAnFMhAbRVQ8K7dKkKs-d62vFMS8sjEBlZk-DAa6yxE-_tAqjQK28XG851kpXtqWnMH6ip8sYvTHf8L2tKnBn_lndZhIIcE3AVSDfqh18YRJLyUouOuq4',
    'Access-api-key': "eyJpdiI6IkhOdThNZ1hVemlBZzhVQnNOazJZOEE9PSIsInZhbHVlIjoiY1QrOGx1UGdsUWJOZnJ2RWY5K0ZjZz09IiwibWFjIjoiZmQzMDcxYTFiZTU1MWNjMTdmZWVmZGQxNWYyMjRiMzBiM2MwZmQ4NWQxMjJjZmI0YzM3Mzg3YTM0Y2EzOTczZCIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IkxTWGhTWUZnV1gwUG9acWY1ekxmRFE9PSIsInZhbHVlIjoic0NtVHNhU3dMd0ZlQ1hSYkpWV00wQT09IiwibWFjIjoiZmJhMTg5ZDNjNTA4YjJkMmVkY2RjYzVlMDhkNTY0ZDUxYTRiNDM2OTJhZDg1YTA4NDM3NmM3ZWUxNGY1NjQ1ZSIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: "GTM-MCNRHV"
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage1Avaleht />} exact />;
                                                                    <Route path="/et/voimalused" element={<Webpage4V__imalused />} exact />;
                                                                    <Route path="/et/e-arved" element={<Webpage5E_arved />} exact />;
                                                                    <Route path="/et/kontakt" element={<Webpage7Kontakt />} exact />;
                                                                    <Route path="/et/privacyPolicy" element={<Webpage8Privaatsuspoliitika />} exact />;
                                                                    <Route path="/et/templates" element={<Webpage9Templates />} exact />;
                                                                    <Route path="/et/kassaseadmed" element={<Webpage10Kassaseadmed />} exact />;
                                                                    <Route path="/et/*" element={<Webpage11Lehte_ei_leitud />} exact />;
                                                <Route path="*" element={<Webpage11Lehte_ei_leitud />} exact />;
                                                                    <Route path="/et/tingimused" element={<Webpage49Tingimused />} exact />;
                                                                    <Route path="/et/kassasusteemid" element={<Webpage50Kassas__steemid />} exact />;
                                                                    <Route path="/et/kassasusteemide-muuk" element={<Webpage51Kassas__steemide_m____k />} exact />;
                                                                    <Route path="/et/pos-tarkvara" element={<Webpage52Pos_tarkvara />} exact />;
                                                                    <Route path="/et/tanuleht" element={<Webpage53T__nuleht />} exact />;
                                                                    <Route path="/et/paketid" element={<Webpage54paketid />} exact />;
                                                                
                                            <Route path="https://a.kassahaldus.ee" element={<Redirect to="https://kassahaldus.ee/et/e-arved" />} exact />;
                                            <Route path="/kassaseadmed" element={<Redirect to="/et/kassaseadmed" />} exact />;
                                            <Route path="/kassasusteemid" element={<Redirect to="/et/kassasusteemid" />} exact />;
                                            <Route path="/kassasusteemide-muuk" element={<Redirect to="/et/kassasusteemide-muuk" />} exact />;
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}